import { Action } from "redux";

export const CHANGES_LOADED = "CHANGES_LOADED";

export const changesLoadedAction = (): Action => {
    return {
        type: CHANGES_LOADED,
    };
};
